import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * What the reader sees when the graph could not be drawn and the automatic rebuilds are spent
 * (app#349). It replaces an empty canvas that only a page reload could fix: the rest of the page
 * keeps working, and the button draws the graph again from the data the app holds now.
 */
export default function GraphFailed({ onRedraw }: { onRedraw: () => void }) {
  return (
    <Box
      role="alert"
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        textAlign: 'center',
        maxWidth: 320,
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        The network graph could not be drawn.
      </Typography>
      <Button variant="outlined" color="secondary" size="small" onClick={onRedraw}>
        Draw again
      </Button>
    </Box>
  )
}
